export const checkIfHome = (slug: string) => slug === '/' ? '' : slug;
